// extracted by mini-css-extract-plugin
export default {"video":"App_video__A3LxI"};